document.addEventListener('DOMContentLoaded', function() {
  advance();
});

var advance = function advance() {
  
  if(typeof quickAddButton == 'function'){
    quickAddButton();
  }
  let swiper = new Swiper('.other-coll-slider',{
    loop: false,
    slidesPerView: "auto",
    navigation: {
      nextEl: '.other-coll-inr .swiper-button-next',
      prevEl: '.other-coll-inr .swiper-button-prev',
    },
    a11y: false,
    pagination: {
      el: ".other-coll-inr .swiper-pagination",
      type: "progressbar"
    },
  })
  document.querySelectorAll('.quick_view_button').forEach((quickBtn) => {
    quickBtn.addEventListener('click',function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      let url = quickBtn.getAttribute('data-url');
      let modal = quickBtn.getAttribute('data-modal');
      fetch(url)
      .then((response) => response.text())
      .then((response) => {
        const html = new DOMParser().parseFromString(response, 'text/html');
        const source = html.getElementById('section-quick-buy');
        document.querySelector('body').classList.add('open-quick-buy');
        document.getElementById(modal).getElementsByClassName('quick-buy-popup')[0].innerHTML = source.innerHTML;
        addToCart();
      })
      .catch((e) => {console.error(e);})
    })
  })
}
if(document.querySelectorAll('.variant-grid')){
  function quickAddButton(){
    document.querySelectorAll('.variant-grid').forEach(function(sizeList){
      sizeList.addEventListener('click',function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        let variant_id;
        sizeList.closest('.grid-size-variants').querySelectorAll('.variant-grid').forEach(function(removeActive){
          removeActive.classList.remove('active');
        });
        sizeList.classList.add('active');
        let nextSibling = sizeList.closest('.grid-variant-outer-wrap').nextElementSibling;
        let prevSibling = sizeList.closest('.grid-variant-outer-wrap').previousElementSibling;
        if(nextSibling || prevSibling){
          if(nextSibling) nextSibling.querySelectorAll('grid-size-variants li').forEach((siblingList) => {
            if(!siblingList.classList.contains('active')){
              return false;
            }
          })
          if(prevSibling) prevSibling.querySelectorAll('grid-size-variants li').forEach((siblingList) => {
            if(!siblingList.classList.contains('active')){
              return false;
            }
          })
          let combineValue = '';
          let count = 0;
          sizeList.closest('.grid-variant-outer').querySelectorAll('.variant-grid.active').forEach((activeValue) => {
            count++;
            if(combineValue == ''){
              combineValue = activeValue.getAttribute('data-title')
            }else{
              combineValue = combineValue + ' / ' + activeValue.getAttribute('data-title')
            }
          })
          sizeList.closest('.grid-imagebox').querySelectorAll('.combine-variant-detail li').forEach((finalList) => {
            let title = finalList.getAttribute('data-title');
            if(title == combineValue){
              variant_id = finalList.dataset.id;
            }
          })
        }else{
          variant_id = sizeList.dataset.id;
        }
        console.log('variant_id',variant_id);
        if(variant_id != undefined){
          let error_grid_outer = sizeList.closest('.snippet-product-grid');
          let error_grid = error_grid_outer.querySelector('.grid-error');
          let formData = {
            'items': [{
              'id': variant_id,
              'quantity': 1
            }]
          };
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
          })
          .then((response) => response.json())
          .then((data) => {
            if(data.status == 422)
            {
              error_grid.innerHTML = data.description;
              setTimeout(function(e){
                error_grid.innerHTML = '';
              },2000);
            }else{
              if(document.location.href.indexOf('/cart') > -1) {
                window.location.href = "/cart";
              }else{
                if(typeof load_cart == 'function'){
                  load_cart();
                  setTimeout(function(e){
                    document.querySelector('body').classList.remove('stickybar');
                    document.querySelector('body').classList.add('open-drawer');
                  },500);
                }else{
                  window.location.href = "/cart";
                }          
              }
              sizeList.closest('.grid-size-variants').querySelectorAll('.variant-grid').forEach(function(removeActive){
                removeActive.classList.remove('active');
              });
              const url = '/cart.js';
              fetch(url)
              .then((resp) => resp.json())
              .then(function(data) {
                var cart_count = data.item_count;
                if(cart_count>0){
                  document.querySelector('.cart-count').innerHTML = cart_count;
                }else{
                  document.querySelector('.cart-count').innerHTML = '';
                }
              })
              .catch(function(error) {
                console.log(error);
              })
            }
            gtag("event", "add_to_cart", {
              currency: Shopify.currency.active,
              value: data.items[0].price,
              items: [
                {
                  item_id: data.items[0].product_id,
                  item_name: data.items[0].product_title,
                  affiliation: "Google Merchandise Store",
                  discount: data.items[0].price - (data.items[0].price * 0.10),
                  index: 0,
                  item_brand: data.items[0].product_type,
                  item_list_id: "related_products",
                  item_list_name: "Related Products",
                  item_variant: data.items[0].variant_title,
                  price: data.items[0].price,
                  quantity: data.items[0].quantity
                }
              ]
            });
          })
          .catch((error) => {
            console.error(error);
          });
        }
        
      });
    });
  }
  quickAddButton();
}

var infinitescroll = {
  scolljs: function() {
    var endlessScroll = new Ajaxinate({
      container: '#product-grid',
      pagination: '#AjaxinatePagination',
      loadingText: document.getElementById('AjaxinatePagination').dataset.text,
      callback: function() {
        advance();
        quickAddButton();
      },
      offset: 3000
    });
  }
}

infinitescroll.scolljs();


document.addEventListener('scroll', function(e) {
  var totalpage = document.querySelector('#AjaxinatePagination a')?.dataset?.page ?? sessionStorage?.getItem('totalpage');
  sessionStorage.scrollPos = document.documentElement.scrollTop;
  sessionStorage.totalpage = totalpage;
});
if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
  var scrollTop=sessionStorage?.getItem('scrollPos')
  document.documentElement.scrollTop = scrollTop ??  document.body.scrollTop;
  window.scrollTo(0,0);
  scrollManualy(scrollTop);
  function scrollManualy(scrollTop){
    scrollTop = parseInt(scrollTop);
    window.scrollTo(0,scrollTop)
    setTimeout(function(){
      if(window.scrollY < scrollTop){
        scrollManualy(scrollTop)
      }
    },1000);
  }
}
document.addEventListener("DOMContentLoaded", (event) => {
  if(document.querySelectorAll('.facet-list h3')){
    document.querySelectorAll('.facet-list h3').forEach((filterAcco) => {
      filterAcco.addEventListener('click',function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        if(filterAcco.closest('.facet-list').classList.contains("active")){
          filterAcco.closest('.facet-list').classList.remove("active");
          const content = filterAcco.closest('.facet-list').querySelector(".filter-inr-wrap");
          content.style.maxHeight = '0px';
        }else{
          filterAcco.closest('.facet-list').classList.add("active");
          const content = filterAcco.closest('.facet-list').querySelector(".filter-inr-wrap");
          if(content.querySelector("ul")){
            content.style.maxHeight = content.querySelector("ul").scrollHeight + "px";
          }else if(content.querySelector(".rangeclswrap")){
            content.style.maxHeight = content.querySelector(".rangeclswrap").scrollHeight + "px";
          }
        }
      })
    })
  }
});
if (window.innerWidth < 992) {
  window.addEventListener('scroll', function() {
      var sectionFooter = document.querySelector('.section-footer');
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var section = sectionFooter.offsetTop - scrollTop - window.innerHeight;
      var filterButtons = document.querySelectorAll('.filter-button');
      filterButtons.forEach(function(button) {
          if (section < 0) {
              button.style.display = 'none';
          } else {
              button.style.display = 'inline-flex';
          }
      });
  });
}